import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import PaginationRequest from '../../../Common/RequestModels/PaginationRequest';
import DocumentTypeEnum from '../../../Spirit/Entities/Enums/DocumentTypeEnum';
import DocumentUpdateRequest from '../../../Spirit/Admin/Interfaces/Models/DocumentService/DocumentUpdateRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import DocumentResponse from '../../../Spirit/Admin/Interfaces/Models/DocumentService/DocumentResponse';

export default class DocumentService {
	webApiService: WebApiService;
	GetListEvent = new Events<WsResponseModelT<Array<DocumentResponse>>>();
	GetDocumentByIdEvent = new Events<WsResponseModelT<DocumentResponse>>();
	UpdateEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('DocumentService', 'GetList', (res: WsResponseModelT<Array<DocumentResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('DocumentService', 'GetDocumentById', (res: WsResponseModelT<DocumentResponse>) => {
			self.GetDocumentByIdEvent.trigger(res);
		});
		webApiService.on('DocumentService', 'Update', (res: WsResponseModelT<Boolean>) => {
			self.UpdateEvent.trigger(res);
		});
	}
	GetList(request: PaginationRequest = null) { 	
        this.webApiService.send('DocumentService', 'GetList' , request);
    }
	GetDocumentById(id: DocumentTypeEnum = null) { 	
        this.webApiService.send('DocumentService', 'GetDocumentById' , id);
    }
	Update(request: DocumentUpdateRequest = null) { 	
        this.webApiService.send('DocumentService', 'Update' , request);
    }
	 // async methods
	async getListAsync(request: PaginationRequest = null): Promise<Array<DocumentResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async getDocumentByIdAsync(id: DocumentTypeEnum = null): Promise<DocumentResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDocumentById.bind(this), this.GetDocumentByIdEvent)(id);
	}
	async updateAsync(request: DocumentUpdateRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Update.bind(this), this.UpdateEvent)(request);
	}
}